import { IChangeEvent, IInputTextFilter } from "../../../interfaces/IInput";
import { formatDate, formatDateToYYYYMMDD } from "../../../functions/kit-mdtw/dates";
import { useState } from "react";
import RutListFilter from "../RutListFilter/RutListFilter";

export default (props: IInputTextFilter) => {
  const {
    placeholder,
    typeFilter,
    onValueChange,
    onPropertyChange,
    onPermaValues,
  } = props;
  const [valueCustomized, setValueCustomized] = useState<string>("");
  const [valid, setValid] = useState<boolean>(true);

  let dateInput: string = "";

  const handleChangeEventError = (event: IChangeEvent) => {
    const { value } = event;
    setValid(true);

    if ((["text", "number"]).includes(typeFilter)) {
      return setValueCustomized(value);
    }

    if (typeFilter == "date") {
      dateInput = formatDate({
        date: value.split("/").join("").split("-").join(""),
      });

      if (dateInput !== "") {
        if (
          !dateInput.match(/^([\d]{2})+([/]{1})+([\d]{2})+([/]{1})+([\d]{4})$/)
        ) {
          setValid(false);
        } else if (dateInput.length < 8) {
          setValid(false);
        }
      }
      setValueCustomized(dateInput);
    }
  };

  const handleChangeEventPress = (event: IChangeEvent) => {
    const { value } = event;

    if (onPermaValues && onPropertyChange && onValueChange) {
      if (onPropertyChange[onPermaValues].includes(value)) {
        return;
      }
      if (value !== "") {
        if (typeFilter == "date") {
          const dateInputFormat = formatDate({
            date: value.split("/").join("").split("-").join(""),
          });
          dateInput = formatDateToYYYYMMDD({date: dateInputFormat, format: "-"})
        }
        const current = { ...onPropertyChange };
        typeFilter == "date" && current[onPermaValues].push(dateInput)
        typeFilter == "text" && current[onPermaValues].push(value)
        typeFilter == "number" && current[onPermaValues].push(Number(value))
        onValueChange(current);
      }
    }
  };

  const handleKeyDown = (eventKey: any) => {
    const { key, target } = eventKey;
    if (key === "Enter") {
      if (typeFilter === "date") {
        if (!valid) {
          return;
        }
        handleChangeEventPress({ value: target.value });
        target.value = "";
        setValueCustomized("")
        setValid(true)
      } else {
        handleChangeEventPress({ value: target.value });
        target.value = "";
        setValueCustomized("")
        setValid(true)
      }
    }
  };

  // RUT: mismo comportamiento que el filtro de RUT de Postulaciones. Se puede
  // pegar una lista de RUTs (uno por línea, o separados por coma/punto y coma),
  // se validan en vivo (chip verde/rojo) y al presionar "Agregar RUTs válidos"
  // se agregan al filtro solo los válidos (sin duplicados). Los agregados se
  // muestran como chips removibles (los pinta InputFiltro con onPropertyChange).
  const handleApplyRuts = (validRuts: string[]) => {
    if (!(onPermaValues && onPropertyChange && onValueChange)) return;
    const current = { ...onPropertyChange };
    const existing: string[] = current[onPermaValues] ?? [];
    const toAdd = validRuts.filter((rut) => !existing.includes(rut));
    if (toAdd.length === 0) return;
    current[onPermaValues] = [...existing, ...toAdd];
    onValueChange(current);
  };

  const handleRemoveRut = (rut: string) => {
    if (!(onPermaValues && onPropertyChange && onValueChange)) return;
    const current = { ...onPropertyChange };
    current[onPermaValues] = (current[onPermaValues] ?? []).filter(
      (item: string) => item !== rut,
    );
    onValueChange(current);
  };

  const handleClearRuts = () => {
    if (!(onPermaValues && onPropertyChange && onValueChange)) return;
    const current = { ...onPropertyChange };
    current[onPermaValues] = [];
    onValueChange(current);
  };

  if (typeFilter === "rut") {
    return (
      <div className={`cols-not-required`}>
        <RutListFilter
          value={valueCustomized}
          onChange={setValueCustomized}
          onApply={handleApplyRuts}
          appliedValues={
            onPropertyChange && onPermaValues
              ? (onPropertyChange[onPermaValues] as string[]) ?? []
              : []
          }
          onRemove={handleRemoveRut}
          onClearAll={handleClearRuts}
        />
      </div>
    );
  }

  return (
    <div className={`cols-not-required`}>
      <input
        type={typeFilter == "number" ? "number" : "text"}
        value={valueCustomized}
        onChange={({ target }) =>
        handleChangeEventError({ value: target.value })
        }
        placeholder={placeholder}
        className={`input-initial initial`}
        onKeyDown={(event) => handleKeyDown(event)}
      />
      {/* Antes "valid" no se mostraba en ningún lado: una fecha
          mal escrita simplemente no se agregaba al presionar Enter, sin
          decir por qué. */}
      {!valid && (
        <span style={{ display: "block", color: "#a33b2e", fontSize: "12px", marginTop: "2px" }}>
          {"Fecha inválida"}
        </span>
      )}
    </div>
  );
};
